export {
  PRIMARY_CONTROLS_STRIP_EXPANSION_HIDDEN,
  PrimaryControlsStripExpansionContext,
  createPrimaryControlsStripExpansionRegistry,
  type PrimaryControlsStripExpansionEntry,
  type PrimaryControlsStripExpansionPublishHandle,
  type PrimaryControlsStripExpansionRegistry,
} from "#primary-controls-strip-expansion-context";
export { PrimaryControlsStripExpansionProvider } from "#primary-controls-strip-expansion-provider";
